import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

export function StatTile({ label, value, hint, tone, className }: {
  label: string
  value: ReactNode
  hint?: ReactNode
  tone?: "success" | "danger"
  className?: string
}) {
  return (
    <div className={cn("rounded-xl border border-border bg-muted/20 px-3 py-2.5", className)}>
      <p className="text-xs text-muted-foreground">{label}</p>
      <p className={cn("font-display mt-1 text-lg font-extrabold", tone === "success" && "text-success", tone === "danger" && "text-destructive")}>{value}</p>
      {hint !== undefined && <p className="muted mt-0.5 text-[10px] leading-tight">{hint}</p>}
    </div>
  )
}
